<template>
  <div class="container-fluid login-signup-wrapper">
    <div class="row">
      <div class="container">
        <div class="backtohomepage d-flex flex-row justify-content-end">
          <router-link :to="{ name: 'event-list' }" class="d-flex flex-row align-items-center">
            <span>
              <i class="fal fa-angle-left"></i>
            </span>
            <span>Back to home page</span>
          </router-link>
        </div>
        <div class="loginsignup d-flex flex-wrap">
          <div
            class="loginsignup-banner d-flex flex-column justify-content-between"
            style="background-image: url(/images/member-benefits-bg.jpg);"
          >
            <div class="logo">
              <img alt="A Experiential Star" class="img-fluid d-block" src="/images/logo.svg" />
            </div>
            <div class="member-benefits">
              <h5>Member benefits</h5>
              <div class="benefits-group d-flex flex-column">
                <div class="benefits-item d-flex flex-row align-items-start">
                  <span>
                    <i class="fal fa-check"></i>
                  </span>
                  <span>
                    Exclusive members only offers from your chosen
                    experiences.
                  </span>
                </div>
                <div class="benefits-item d-flex flex-row align-items-start">
                  <span>
                    <i class="fal fa-check"></i>
                  </span>
                  <span>Invitations to exclusive members only experiences.</span>
                </div>
                <div class="benefits-item d-flex flex-row align-items-start">
                  <span>
                    <i class="fal fa-check"></i>
                  </span>
                  <span>Build and share your bucket-list.</span>
                </div>
                <div class="benefits-item d-flex flex-row align-items-start">
                  <span>
                    <i class="fal fa-check"></i>
                  </span>
                  <span>No signup fee or contract.</span>
                </div>
              </div>
            </div>
          </div>
          <div class="loginsignup-content d-flex flex-column justify-content-center">
            <h2>Reset your Password</h2>
            <p>Login with your account</p>
            <form class="loginsignup-form" id="login-modal" @submit.prevent="submit">
              <div class="form-group">
                <label for="email" class="control-label">Email Address</label>
                <input
                  type="email"
                  id="email"
                  class="form-control"
                  name="email"
                  v-model="form.email"
                />
              </div>
              <div class="form-group">
                <label for="password" class="control-label">Password</label>
                <input
                  type="password"
                  class="form-control"
                  id="password"
                  name="password"
                  v-model="form.password"
                />

                <!-- <p class="text-danger" v-text="errors.get('password')"></p> -->
              </div>
              <div class="form-group">
                <label for="password" class="control-label">Confirm Password</label>
                <input
                  type="password"
                  class="form-control"
                  id="password"
                  name="password"
                  v-model="form.password_confirmation"
                />

                <!-- <p class="text-danger" v-text="errors.get('password')"></p> -->
              </div>
              <div class="form-group d-flex flex-row">
                <button type="submit" role="button" class="submit-button button" :disabled="disabled">Reset Password</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventService from '@/services/EventService.js'
import metaInfoMixin from '../mixins/metaInfo'
import { mapActions } from 'vuex'

export default {
  mixins: [metaInfoMixin],
  data() {
    return {
      form: {
        email: '',
        password: '',
        password_confirmation:'',
        token: null,
      },
      confirm_code: this.$route.query.code,
      confirmed_user: [],
      disabled:false
    }
  },
  methods: {
    ...mapActions({
      resetPasswordSubmit: 'auth/resetPasswordSubmit'
    }),
    submit() {
      this.disabled = true
      this.form.token = this.$route.params.token
     this.resetPasswordSubmit(this.form)
        .then((res) => {
          
          this.$swal({
            // title: 'Error!',
            text: res.data.message,
            // icon: 'success',
            // confirmButtonText: 'Try Again',
            toast: true,
            position: 'top-end',
            timer: 2200,
            timerProgressBar: true,
            padding: '15px',
            showConfirmButton: true
          })
          this.$router.replace({
            name: 'page-login'
          })
          this.disabled = false
          this.form.email= ''
          this.form.password= ''
          this.form.password_confirmation=''
          this.form.token= null
        })
        .catch(error => {
          this.disabled = false
            this.$swal({
              title: 'Error!',
              text: error.message,
              icon: 'error',
              // confirmButtonText: 'Try Again',
              toast: true,
              position: 'top',
              timer: 2200,
              timerProgressBar: true,
              padding: '15px'
              // showConfirmButton: false
            })
         
        })
    }
  },

  created() {
    if (this.$route.query.code) {
      EventService.getUserByCode(this.$route.query.code)
        .then(response => {
          // console.log(response.data)
          this.confirmed_user = response.data
          alert('you have been confirmed ' + this.confirmed_user.name)
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    }
    this.setMetaInfo({
      title: 'Forgot Password',
      desc: '',
      keywords: '',
      img: '',
      url: window.location.href
    })
  }
}
</script>

<style lang="scss" scoped></style>
